import { HoverHintContent } from "@/components/ui/title-help";
import { cn } from "@/lib/utils";

import type { FirmwareSerialDeviceSkuCount } from "./firmwareApi";
import { FirmwareSerialDeviceCountHint } from "./FirmwareSerialDeviceCountHint";

export function FirmwareDeferredDeviceCount({
  count,
  ready,
  hoverHint,
  bySku = [],
}: {
  count: number | null;
  ready: boolean;
  hoverHint: string;
  bySku?: FirmwareSerialDeviceSkuCount[];
}): JSX.Element {
  if (ready) {
    return <FirmwareSerialDeviceCountHint bySku={bySku}>{count ?? 0}</FirmwareSerialDeviceCountHint>;
  }
  return (
    <HoverHintContent hoverHint={hoverHint}>
      <span
        className={cn(
          "inline-block select-none tabular-nums text-slate-400 blur-[3px]",
        )}
        aria-busy="true"
        aria-label="Loading device count"
      >
        88
      </span>
    </HoverHintContent>
  );
}
